/**
 * Yatak Katman Gosterim JavaScript
 * Shopify Impact Temasi Uyumlu
 */

(function() {
  'use strict';

  // Gorsel yukleme fonksiyonu
  async function loadImages(imageUrlArray, wrapper) {
    const promiseArray = [];

    for (let imageUrl of imageUrlArray) {
      promiseArray.push(new Promise(resolve => {
        const img = new Image();
        img.onload = function() {
          resolve();
        };
        img.onerror = function() {
          resolve(); // Hata olsa bile devam et
        };
        img.src = imageUrl;
      }));
    }

    await Promise.all(promiseArray);
    return afterLoaded(wrapper);
  }

  // Yuklenme tamamlandiktan sonra calisacak fonksiyon
  function afterLoaded(wrapper) {
    setTimeout(() => {
      wrapper.classList.add('imgs-loaded');
    }, 500);

    // Loading elementini kaldir
    const loading = wrapper.parentElement.querySelector('.layer-loading');
    if (loading) {
      loading.remove();
    }
  }

  // Element gorunur alanda mi kontrolu
  function elementInView(el, dividend = 1) {
    const elementTop = el.getBoundingClientRect().top;
    return elementTop <= (window.innerHeight || document.documentElement.clientHeight) / dividend;
  }

  // Element gorunur alan disinda mi kontrolu
  function elementOutofView(el) {
    const elementTop = el.getBoundingClientRect().top;
    return elementTop > (window.innerHeight || document.documentElement.clientHeight);
  }

  // Scroll animasyonu - gorunur yapma
  function displayScrollElement(element) {
    setTimeout(() => {
      element.classList.add('loaded');
    }, 1000);
  }

  // Scroll animasyonu - gizleme
  function hideScrollElement(element) {
    setTimeout(() => {
      element.classList.remove('loaded');
    }, 1000);
  }

  // Scroll animasyonu handler
  function handleScrollAnimation(wrapper) {
    if (elementInView(wrapper, 1.25)) {
      displayScrollElement(wrapper);
    } else if (elementOutofView(wrapper)) {
      hideScrollElement(wrapper);
    }
  }

  // Tum secili siniflari kaldir
  function removeAllSelectedClass(container) {
    const figures = container.querySelectorAll('.figure');
    const articles = container.querySelectorAll('.figure-article');

    figures.forEach(el => el.classList.remove('selected'));
    articles.forEach(el => el.classList.remove('show'));
  }

  // Mobil basligi guncelle
  function refreshTitleTextContent(titleElement, container) {
    const target = container.querySelector('.figure-article.show .title');
    if (target && titleElement) {
      const text = target.innerText || target.textContent;
      titleElement.innerHTML = text;
    }
  }

  // Katman bilesenini baslat
  function initProductLayers(container) {
    const wrapper = container.querySelector('.wrapper');
    const figures = wrapper.querySelectorAll('.figure');
    const mobileTitle = container.querySelector('.mobile-title');

    // Katman sayisi class'larini kontrol et (liquid tarafindan eklenmis olmali)
    const layerCount = parseInt(container.dataset.layerCount) || figures.length;

    // Class'larin dogru eklendiginden emin ol
    if (!wrapper.classList.contains('l-' + layerCount)) {
      wrapper.classList.add('l-' + layerCount);
    }
    if (!container.classList.contains('gl-' + layerCount)) {
      container.classList.add('gl-' + layerCount);
    }

    // Tum gorsel URL'lerini topla
    const imgArray = wrapper.querySelectorAll('.figure img');
    const srcArray = [];
    imgArray.forEach(img => {
      if (img.src) {
        srcArray.push(img.src);
      }
    });

    // Gorselleri yukle
    loadImages(srcArray, wrapper);

    // Mobil baslik zaten liquid tarafindan eklenmis, sadece guncelle
    if (mobileTitle) {
      refreshTitleTextContent(mobileTitle, container);
    }

    // Figure click event'leri
    figures.forEach((figure, index) => {
      // Ilk figure haric selected class'i kaldir (liquid zaten ayarlamis olmali)
      if (index !== 0 && figure.classList.contains('selected')) {
        figure.classList.remove('selected');
      }

      // Click event
      figure.addEventListener('click', function() {
        removeAllSelectedClass(container);

        // Ilgili article'i goster
        const articles = container.querySelectorAll('.figure-article');
        const figureIndex = Array.prototype.indexOf.call(this.parentElement.children, this);

        if (articles[figureIndex]) {
          articles[figureIndex].classList.add('show');
        }

        // Mobil basligi guncelle
        if (mobileTitle) {
          refreshTitleTextContent(mobileTitle, container);
        }

        // Bu figure'i secili yap
        this.classList.add('selected');
      });

      // Hover event'leri
      figure.addEventListener('mouseover', function() {
        const figureIndex = Array.prototype.indexOf.call(this.parentElement.children, this);
        wrapper.classList.add('hovered-' + (figureIndex + 1));
      });

      figure.addEventListener('mouseout', function() {
        const figureIndex = Array.prototype.indexOf.call(this.parentElement.children, this);
        wrapper.classList.remove('hovered-' + (figureIndex + 1));
      });

      // Touch event'leri (mobil icin)
      figure.addEventListener('touchstart', function(e) {
        // Hover efekti icin
        const figureIndex = Array.prototype.indexOf.call(this.parentElement.children, this);
        wrapper.classList.add('hovered-' + (figureIndex + 1));
      }, { passive: true });

      figure.addEventListener('touchend', function() {
        // Tum hover class'larini kaldir
        for (let i = 1; i <= 12; i++) {
          wrapper.classList.remove('hovered-' + i);
        }
      }, { passive: true });
    });

    // Scroll event'i
    function onScroll() {
      handleScrollAnimation(wrapper);
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    // Ilk yuklenmede scroll event'ini tetikle
    window.dispatchEvent(new CustomEvent('scroll'));
  }

  // Sayfa yuklendiginde tum katman bilesenlerini baslat
  function init() {
    const containers = document.querySelectorAll('.product-layers.kesitler');
    containers.forEach(container => {
      initProductLayers(container);
    });
  }

  // DOM hazir oldugunda baslat
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify section render event'lerini dinle (tema editoru icin)
  document.addEventListener('shopify:section:load', function(event) {
    const section = event.target;
    const container = section.querySelector('.product-layers.kesitler');
    if (container) {
      initProductLayers(container);
    }
  });

})();
